import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useDocumentService } from 'src/apis/documents/useDocumentService';
import { TCreateDocumentRequest, TDocumentResponse } from 'src/apis/documents/documents.interfaces';
import { getStudentDocumentsKey } from './useStudentDocumentsHook';

type TMutationError = IFHError<{ message: string }>;
type TCreateDocumentPayload = TCreateDocumentRequest & { file?: File };

export const useCreateDocumentMutationHook = (
  options?: UseMutationOptions<
    TDocumentResponse,
    TMutationError,
    TCreateDocumentPayload,
    unknown
  >
) => {
  const { createDocument } = useDocumentService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: TCreateDocumentPayload) => createDocument(request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getStudentDocumentsKey],
      });
    },
    ...options,
  });
};
